var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            size: "lg",
            "no-close-on-backdrop": "",
            "hide-header-close": "",
            title: "Relatório de pagamento de comissão"
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            disabled: _vm.loadAtt || _vm.loading,
                            size: "sm",
                            variant: "success"
                          },
                          on: {
                            click: function($event) {
                              return _vm.gerarRelatorio("PDF")
                            }
                          }
                        },
                        [
                          !_vm.loadAtt || !_vm.loading
                            ? _c("i", { staticClass: "fas fa-chart-bar" })
                            : _c("b-spinner", { attrs: { small: "" } }),
                          _vm._v("\n          Gerar\n        ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            size: "sm",
                            variant: "warning"
                          },
                          on: {
                            click: function($event) {
                              return _vm.gerarRelatorio("XLSX")
                            }
                          }
                        },
                        [
                          !_vm.loadAtt || !_vm.loading
                            ? _c("i", { staticClass: "fas fa-file-excel" })
                            : _c("b-spinner", { attrs: { small: "" } }),
                          _vm._v("\n          Exportar\n        ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            size: "sm",
                            variant: "danger"
                          },
                          on: { click: _vm.statusModal }
                        },
                        [_vm._v("Fechar")]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.state,
            callback: function($$v) {
              _vm.state = $$v
            },
            expression: "state"
          }
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    [
                      _c("b-form-radio-group", {
                        attrs: { options: _vm.optionsTipoUser, plain: "" },
                        model: {
                          value: _vm.tipoUsuario,
                          callback: function($$v) {
                            _vm.tipoUsuario = $$v
                          },
                          expression: "tipoUsuario"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.tipoUsuario == "P"
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Preposto")]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: { options: _vm.prepostos },
                        model: {
                          value: _vm.preposto,
                          callback: function($$v) {
                            _vm.preposto = $$v
                          },
                          expression: "preposto"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tipoUsuario == "R"
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Representante")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: { options: _vm.representantes },
                        model: {
                          value: _vm.representante,
                          callback: function($$v) {
                            _vm.representante = $$v
                          },
                          expression: "representante"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tipoUsuario == "G"
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Gerente")]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: { options: _vm.gerentes },
                        model: {
                          value: _vm.gerente,
                          callback: function($$v) {
                            _vm.gerente = $$v
                          },
                          expression: "gerente"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tipoUsuario == "G"
            ? _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Porcentagem %")
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["#", "#.#", "#.##", "##.##"],
                            expression: "['#', '#.#', '#.##', '##.##']"
                          }
                        ],
                        attrs: { placeholder: "3.00" },
                        model: {
                          value: _vm.porcentagem,
                          callback: function($$v) {
                            _vm.porcentagem = $$v
                          },
                          expression: "porcentagem"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tipo == "COMISSAO"
            ? _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Mês")]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: { options: _vm.optionsMes },
                        model: {
                          value: _vm.mes,
                          callback: function($$v) {
                            _vm.mes = $$v
                          },
                          expression: "mes"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Ano")]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: { options: _vm.optionsAno },
                        model: {
                          value: _vm.ano,
                          callback: function($$v) {
                            _vm.ano = $$v
                          },
                          expression: "ano"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tipo == "COMISSAO"
            ? _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Status dos Titulos")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: { options: _vm.optionsStatus },
                        model: {
                          value: _vm.status,
                          callback: function($$v) {
                            _vm.status = $$v
                          },
                          expression: "status"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bb18569", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bb18569","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/relatorios/componentes/relatorio-varejo.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4bb18569","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/relatorios/componentes/relatorio-varejo.vue
// module chunks = 2